import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import * as React from 'react';

import { cn } from '@heidi/utils';

import {
  accordionContentClasses,
  accordionContentInnerClasses,
  accordionHeaderClasses,
  accordionItemClasses,
  accordionTriggerClasses,
  accordionTriggerIconClasses,
} from './accordion.styles';
import type {
  AccordionContentProps,
  AccordionItemProps,
  AccordionTriggerProps,
} from './accordion.types';

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  AccordionItemProps
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn(accordionItemClasses, className)}
    {...props}
  />
));
AccordionItem.displayName = 'AccordionItem';

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  AccordionTriggerProps
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className={accordionHeaderClasses}>
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(accordionTriggerClasses, className)}
      {...props}
    >
      {children}
      <ChevronDown className={accordionTriggerIconClasses} />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  AccordionContentProps
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content ref={ref} className={accordionContentClasses} {...props}>
    <div className={cn(accordionContentInnerClasses, className)}>{children}</div>
  </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
